export default __webpack_public_path__ + "static/media/push8.84225b9e.gif";